import { Pipe, PipeTransform, Type } from '@angular/core';
import { TaskType } from 'src/app/tasks-queue/store/tasks-queue.types';
import {
  AutoAcceptBannersComponent
} from 'src/app/tasks-queue/tasks/auto-accept-banners/auto-accept-banners.component';

@Pipe({
  name: 'appComponentByTask',
  standalone: true,
})
export class ComponentByTaskPipe implements PipeTransform {
  public transform(taskType: TaskType): Type<unknown> | null {
    switch (taskType) {
    case TaskType.ACCEPT_CAMPAIGN_BANNERS:
      return AutoAcceptBannersComponent;
    }

    return null;
  }
}
